import { CRITICAL_BATTERY_LEVEL } from "models/constants";
import { TextFieldWithEllipsis } from "UI/TextFiledWithEllipsis";
import { convertDeviceType } from "utils/helpers";

export const buttonColumns = [
  {
    label: "Button ID",
    field: "id",
    xs: 1.25,
    sm: 1.25,
    md: 1.25,
    renderer: ({ id, deviceType }) => (
      <TextFieldWithEllipsis>
        {["Virtual", "Soft", "Digital"].includes(deviceType)
          ? `${String(id).slice(0, 8)}...`
          : id}
      </TextFieldWithEllipsis>
    ),
  },
  {
    label: "Name",
    field: "buttonName",
    xs: 1,
    sm: 1,
    md: 1,
    renderer: ({ buttonName }) => (
      <TextFieldWithEllipsis>
        {buttonName}
      </TextFieldWithEllipsis>
    ),
  },
  {
    label: "Type",
    field: "deviceType",
    xs: 1,
    sm: 1,
    md: 1,
    renderer: ({ deviceType }) => convertDeviceType(deviceType),
  },
  {
    label: "Provider",
    field: "providerName",
    xs: 1.5,
    sm: 1.5,
    md: 1.5,
    renderer: ({ providerName }) => (
      <TextFieldWithEllipsis>{providerName}</TextFieldWithEllipsis>
    ),    
  },
  {
    label: "Sender",
    field: "senders",
    xs: 2,
    sm: 2,
    md: 2,
    renderer: ({ senders }) => (
      <TextFieldWithEllipsis>{senders}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Recipient",
    field: "recipientName",
    xs: 2,
    sm: 2,
    md: 2,
    renderer: ({ recipientName }) => (
      <TextFieldWithEllipsis>{recipientName}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Specialist",
    field: "specialists",
    xs: 2.25,
    sm: 2.25,
    md: 2.25,
    renderer: ({ specialists }) => (
      <TextFieldWithEllipsis>{specialists}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Battery",
    field: "lastBatteryLevel",
    align: "center",
    xs: 1,
    sm: 1,
    md: 1,
    renderer: ({ lastBatteryLevel, deviceType }) =>
      deviceType === "Virtual" ? null : (
        <div
          className={
            lastBatteryLevel <= CRITICAL_BATTERY_LEVEL
              ? "text-red-700"
              : "text-gray-400"
          }
        >
          {lastBatteryLevel ? `${lastBatteryLevel}%` : "N/A"}
        </div>
      ),
  },
];

export const mobileButtonColumns = [
  {
    label: "Button ID",
    field: "id",
    xs: 3,
    sm: 3,
    md: 3,
    renderer: ({ id, deviceType }) => (
      <TextFieldWithEllipsis>
        {["Virtual", "Soft", "Digital"].includes(deviceType)
          ? `${String(id).slice(0, 8)}...`
          : id}
      </TextFieldWithEllipsis>
    ),
  },
  {
    label: "Name",
    field: "buttonName",
    xs: 2,
    sm: 2,
    md: 2,
    renderer: ({ buttonName }) => (
      <TextFieldWithEllipsis>
        {buttonName}
      </TextFieldWithEllipsis>
    ),
  },
  {
    label: "Type",
    field: "deviceType",
    xs: 2,
    sm: 2,
    md: 2,
    renderer: ({ deviceType }) => convertDeviceType(deviceType),
  },
  {
    label: "Provider",
    field: "providerName",
    xs: 2,
    sm: 2,
    md: 2,
    renderer: ({ providerName }) => (
      <TextFieldWithEllipsis>{providerName}</TextFieldWithEllipsis>
    ),    
  },
  {
    label: "Sender",
    field: "senders",
    xs: 3,
    sm: 3,
    md: 3,
    renderer: ({ senders }) => (
      <TextFieldWithEllipsis>{senders}</TextFieldWithEllipsis>
    ),
  },
];